import { useContext, useEffect, useState, useCallback } from 'react';
import { UserContext } from '#src/context/UserContext.js';
import {AddTokenToCompany} from '#src/components/dialogs/addTokenToCompany';
import {TokenInfoModal} from '#src/components/dialogs/tokenInfoModal'
import { ParserDateTime } from '#src/helper/dateFormatHandler';
import { APIGetMyTokens } from '#src/api/token/Token.js';

const maxToken = 5;

export const TokenManagemant = () => {
    const { user } = useContext(UserContext)
    const [showAddToken, setShowAddToken] = useState(false);
    const [showTokenInfo, setShowTokenInfo] = useState(false);
    const [tokens, setTokens] = useState([])
    const [displayToken, setDisplayToken] = useState(0)

    const getTokens = useCallback(async() => {
        const myTokens = await APIGetMyTokens(user.companyId);
        setTokens(myTokens);
    }, [user.companyId])

    const getStatus = (tokenstatus) => {
        if (tokenstatus === 'inactive') {
            return 'Inaktive'
        }
        if (tokenstatus === 'active') {
            return 'Aktiv'
        }
        return '-'
    }

    useEffect(() => {
        getTokens();
    }, [getTokens])

    return (
        <div className="border border-gray-500 rounded-lg bg-white w-full p-6 mb-12 ">
            {(showAddToken && (tokens.length < maxToken)) && <AddTokenToCompany 
                show={showAddToken} 
                setShow={setShowAddToken} 
                getTokens={getTokens}
                maxToken={maxToken}
            />}
            {showTokenInfo && <TokenInfoModal 
                show={showTokenInfo} 
                setShow={setShowTokenInfo} 
                getTokens={getTokens}
                token={tokens[displayToken]}
            />}
            <div className="flex justify-between flex justify-between rounded p-6 pb-5  -m-6 ">
                <div className="sm:flex-auto">
                    <h1 className="text-lg font-semibold text-lg text-gray-900">
                    <span>API-Schlüssel</span><span className='font-medium text-base self-end pb-[1px]'>({tokens?.length}/{maxToken})</span>
                    </h1>
                </div>
                <div className=" sm:ml-16 sm:mt-0 sm:flex-none">
                    <button
                        onClick={() => setShowAddToken(true)}
                        disabled={(tokens.length >= maxToken) ? true : false}
                        type="button"
                        className="disabled:hidden block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Hinzufügen
                    </button>
                </div>
            </div>
            <div className="mt-8 flow-root">
                <div className="">
                    <div className="inline-block min-w-full py-2 align-middle">
                        <table className="w-full divide-y divide-gray-500 table-fixed ">
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-2"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3.5 text-left w-36 text-sm font-semibold text-gray-900"
                                    >
                                        Schlüssel
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3.5 text-left w-32 text-sm font-semibold text-gray-900"
                                    >
                                        Erstellt am
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3.5 text-left w-28 text-sm font-semibold text-gray-900"
                                    >
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {tokens.length > 0 ? (
                                    tokens.slice(0,maxToken).map((token, index) => (
                                        <tr 
                                            key={index}
                                            onClick={() => {
                                                setShowTokenInfo(true)
                                                setDisplayToken(index)
                                            }}
                                            className='cursor-pointer hover:bg-gray-200'
                                        >
                                            <td className="whitespace-nowrap truncate py-4 pl-4 w-2/6 pr-3 text-sm font-medium text-gray-900 sm:pl-2">
                                                {token.name}
                                            </td>
                                            <td className="whitespace-nowrap truncate px-3 py-4 w-2/6 text-sm text-gray-900">
                                                **********
                                            </td>
                                            <td className="whitespace-nowrap truncate px-3  py-4 w-1/6 text-sm text-gray-900">
                                                {ParserDateTime(token.createdAt)}
                                            </td>
                                            <td className="whitespace-nowrap truncate px-3 py-4 w-1/6  text-sm text-gray-900">
                                                {getStatus(token.status)}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4 text-sm text-gray-900">
                                            Kein Schlüssel vorhanden
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
